/* eslint-disable vue/no-side-effects-in-computed-properties */
<template>
  <v-container>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="10000"
      :top="true"
      style="z-index: 20000"
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-expansion-panels hover inset light popout>
      <v-expansion-panel active-class>
        <v-expansion-panel-header
          style="background-color: #007bff"
          color="text-white"
        >
          <template v-slot:actions>
            <v-icon color="white"> $expand </v-icon>
          </template>
          <v-row>
            <v-col cols="12" md="8" sm="8">
              <div style="color: white; font-size: 20px"
                >{{ document.nom + " " + document.prenom }}

              </div>

            </v-col>


              <v-col cols="12" md="4" sm="4">
              <small style="color: white;"
                >{{ document.type_visas}} : {{ formatDate(document.date_depart) + " - " + formatDate(document.date_retour) }}

              </small>
              
            </v-col>

            <v-col cols="12" md="8" class="text-lefts">
              <span style="color: white; font-size: 20px">
                {{ document.type_visa }}</span
              >
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-4">
            <!-- formualr demand -->

            <v-col class="p-3" v-if="document.demand_formular" cols="10" md="9">
              Formulaire demande de visa / Visa request Form
            </v-col>
            <v-col
              v-if="document.demand_formular"
              class="p-3 text-right"
              cols="2"
              md="3"
            >
              <v-btn
                icon
                @click="
                  downlaodFIle('DemandFormular', document.demand_formular)
                "
                target="_blank"
              >
                <v-icon color="blue"> mdi-download </v-icon>
              </v-btn>
            </v-col>
            <!-- registrationi recept -->
            <v-col class="p-3" v-if="document.register_recept" cols="10" md="9">
              Reçu d'inscription /Registraion recept
            </v-col>
            <v-col
              v-if="document.register_recept"
              class="p-3 text-right"
              cols="2"
              md="3"
            >
              <v-btn
                icon
                @click="
                  downlaodFIle('RegisterRecept', document.register_recept)
                "
              >
                <v-icon color="blue"> mdi-download </v-icon>
              </v-btn>
            </v-col>

            <!-- rollup recept -->

            <v-col class="p-3" v-if="document.approved_rollup" cols="10" md="9">
              Pré-enrôlement approuvé / Approuved pre-enrolment
            </v-col>
            <v-col
              v-if="document.approved_rollup"
              class="p-3 text-right"
              cols="2"
              md="3"
            >
              <v-btn
                icon
                @click="
                  downlaodFIle('ApprovedRollup', document.approved_rollup)
                "
              >
                <v-icon color="blue"> mdi-download </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "DocumentDetails",
  props: ["document"],

  components: {},
  watch: {},
  data: () => ({
    snackbar: false,
    snackbarColor: "default",
    snackbar_text: "",
  }),
  computed: {
    ...mapGetters(["currentrole","errors", "registered", "countries"]),
  },

  created() {},

  methods: {

    formatDate(str) {
      return moment(str).subtract(0, "hour").format("L");
    },


    downlaodFIle(route_name, file_link) {
      if (route_name && file_link) {
       
        let routeData = this.$router.resolve({
          name: route_name,
          params: { id: file_link },
        });
        window.open(routeData.href, "_blank");


      } else {
        this.snackbar = true;
        this.snackbarColor = "red";
        this.snackbar_text = "Pas de lien disponible";
      }
    },
  },
};
</script>

<style scoped>
.content-header {
  text-align: left;
  color: #4a4343;
  font-weight: 700;
}
</style>